import styled from 'styled-components'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'

import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsExportData from 'highcharts/modules/export-data'
import HighchartTranslations from "../HighchartsWrapper/highcharts.translations";
import HighchartOptions from "../HighchartsWrapper/highcharts.options";
import { getOptions } from './getOptions'
import { range } from '../../functions/range'

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

const Container = styled.div.withConfig({displayName:'-Container'})`
	background-color: #ffffff;
	width: 100%;
	height: 100%;
`;

/**
 * @param {import('./getOptions').ChartOptions} param0 
 */
export function Chart({
    title, subtitle, name, yTitle, data
}) {

    const opts = getOptions({
        title, subtitle, name, yTitle, data
    })

    return (
        <Container>
            <HighchartsReact
                highcharts={Highcharts}
                constructorType={'stockChart'}
                options={opts}
            />
        </Container>
    )
}